import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'

import { actionSet } from './utils'
import { getPages } from 'component/pagination/utils'

import {
  FETCH_LINEAR_CONFERENCE_REQUEST,
  FETCH_LINEAR_CONFERENCE_SUCCESS,
  FETCH_LINEAR_CONFERENCE_ERROR,

  FETCH_LINEAR_CONFERENCE_FLUX_REQUEST,
  FETCH_LINEAR_CONFERENCE_FLUX_SUCCESS,
  FETCH_LINEAR_CONFERENCE_FLUX_ERROR,

} from 'actionTypes'
import { hideSpinner, showSpinner } from './spinner'

const HAS_PAGINATION = true

const DEFAULT_SIZE = 10

export const fetch = (token, params) => (dispatch) => {
  dispatch(actionSet(FETCH_LINEAR_CONFERENCE_REQUEST))

  const actualPage = params.page || 1

  const pagination = {
    hasPagination: HAS_PAGINATION,
    offset: DEFAULT_SIZE * actualPage - DEFAULT_SIZE,
    page: actualPage,
    size: DEFAULT_SIZE,
  }

  return new Api(token, dispatch)
    .post(API_URL.FETCH_LINEAR_CONFERENCE, {
      ...params,
      ...pagination,
    })
    .then(({ data, metadata }) => {
      dispatch(getPages(metadata))
      dispatch(actionSet(FETCH_LINEAR_CONFERENCE_SUCCESS, data))
    })
    .catch((error) => dispatch(actionSet(FETCH_LINEAR_CONFERENCE_ERROR, error)))
}

// FLUX
export const fetchLinearConferenceFlux =
(token, params, getData, fetchError, signalController) => (dispatch) => {
  dispatch(actionSet(FETCH_LINEAR_CONFERENCE_FLUX_REQUEST))

  const actualPage = params.page || 1

  const pagination = {
    hasPagination: HAS_PAGINATION,
    offset: params.limit * actualPage - params.limit,
    page: actualPage,
    size: params.limit,
  }
  
  const onMessage = (response) =>{
    dispatch(getPages(response.data.pages))
    dispatch(actionSet(FETCH_LINEAR_CONFERENCE_FLUX_SUCCESS, response.data.resultList))
    getData && getData(response.data)
  }

  const onClose = () => {
    dispatch(hideSpinner())
    dispatch(hideSpinner())
  }

  const onError = (error) => {
    dispatch(actionSet(FETCH_LINEAR_CONFERENCE_FLUX_ERROR, error))
    fetchError && fetchError()
  }

  const abort = () => {
    signalController.abort()
    dispatch(hideSpinner())
    dispatch(hideSpinner())
    onClose()
  }

  dispatch(showSpinner("", true, abort))

  return new Api(token, dispatch)
    .eventSourceStream(API_URL.FETCH_LINEAR_CONFERENCE_FLUX, {
      ...params,
      ...pagination,
    }, null, signalController, onMessage, onClose, onError)
    .catch((error) => onError(error))
}
